import { useEffect } from 'react';
import { supabase } from '../lib/supabase';

const SESSION_KEY = 'vl_session_id';
const LAST_LOG_KEY = 'vl_last_log_date';
const CITY_CACHE_KEY = 'vl_city_cache';

function getOrCreateSessionId(): string {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

async function detectCity(): Promise<string | null> {
  const cached = localStorage.getItem(CITY_CACHE_KEY);
  if (cached) return cached;

  try {
    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) });
    if (!res.ok) return null;
    const data = await res.json();
    // 優先使用城市名，fallback 到地區名
    const city: string = data.city || data.region || null;
    if (city) {
      localStorage.setItem(CITY_CACHE_KEY, city);
      return city;
    }
  } catch {
    // 偵測失敗不影響主流程
  }
  return null;
}

export function useVisitorTracking(userId?: string | null) {
  useEffect(() => {
    const logVisit = async () => {
      const today = new Date().toISOString().substring(0, 10);
      const lastLog = localStorage.getItem(LAST_LOG_KEY);

      // 每個 session 每天只記一次
      if (lastLog === today) return;

      const sessionId = getOrCreateSessionId();
      const pagePath = window.location.pathname;
      const city = await detectCity();

      await supabase.from('visitor_logs').insert({
        session_id: sessionId,
        user_id: userId ?? null,
        page_path: pagePath,
        visited_at: new Date().toISOString(),
        city: city ?? null,
      });

      localStorage.setItem(LAST_LOG_KEY, today);
    };

    logVisit();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
